import { useMutation } from '@tanstack/react-query';
import axios from '@/lib/axios';

/**
 * 0030. ユーザ登録（SNSで登録）
 * [POST] /third_party_authentications
 */
type Props = {
  id_token: string;
  invitation: string | null;
};
export const createThirdPartyAuthentication = (props: Props): Promise<any> => {
  return axios.post(`/api/third_party_authentications`, props);
};

export const useCreateThirdPartyAuthentication = () => {
  return useMutation({
    mutationFn: createThirdPartyAuthentication,
  });
};
